export class MessageInboxModel {
  messageInbox: MessageInboxViewModel;
}

export class MessageInboxViewModel {
  groupOrChatName: string;
  isActive: boolean;
  userIds: number[];
}
